import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00119 = new TileLayer({
  title: 'Máscara 20140905',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140905l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00119.setVisible(false);
  
const layer00118 = new TileLayer({
  title: 'Máscara 20140929',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20140929l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00118.setVisible(false);
  
const layer00117 = new TileLayer({
  title: 'Máscara 20141023',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20141023l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00117.setVisible(false);

const layer00116 = new TileLayer({
  title: 'Máscara 20141031',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20141031l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00116.setVisible(false);
  
const layer00115 = new TileLayer({
  title: 'Máscara 20141202',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20141202l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00115.setVisible(false);
  
const layer00114 = new TileLayer({
  title: 'Máscara 20141210',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20141210l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00114.setVisible(false);
  
const layer00113 = new TileLayer({
  title: 'Máscara 20141226',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20141226l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00113.setVisible(false);

const layer00112 = new TileLayer({
  title: 'Máscara 20150103',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150103l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00112.setVisible(false);

const layer00111 = new TileLayer({
  title: 'Máscara 20150111',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150111l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00111.setVisible(false);
 
const layer00110 = new TileLayer({
  title: 'Máscara 20150127',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150127l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00110.setVisible(false);
 
const layer00109 = new TileLayer({
  title: 'Máscara 20150204',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150204l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00109.setVisible(false);
  
const layer00108 = new TileLayer({
  title: 'Máscara 20150228',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150228l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00108.setVisible(false);
  
const layer00107 = new TileLayer({
  title: 'Máscara 20150308',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150308l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00107.setVisible(false);
  
const layer00106 = new TileLayer({
  title: 'Máscara 20150401',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150401l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00106.setVisible(false);
  
const layer00105 = new TileLayer({
  title: 'Máscara 20150511',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150511l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00105.setVisible(false);
  
const layer00104 = new TileLayer({
  title: 'Máscara 20150519',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150519l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00104.setVisible(false);

const layer00103 = new TileLayer({
  title: 'Máscara 20150527',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150527l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00103.setVisible(false);

const layer00102 = new TileLayer({
  title: 'Máscara 20150604',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150604l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00102.setVisible(false);
  
const layer00101 = new TileLayer({
  title: 'Máscara 20150620',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150620l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00101.setVisible(false);
  
const layer00100 = new TileLayer({
  title: 'Máscara 20150628',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150628l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00100.setVisible(false);

const layer0099 = new TileLayer({
  title: 'Máscara 20150706',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150706l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0099.setVisible(false);
  
const layer0098 = new TileLayer({
  title: 'Máscara 20150714',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150714l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0098.setVisible(false);
  
const layer0097 = new TileLayer({
  title: 'Máscara 20150722',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150722l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0097.setVisible(false);
  
const layer0096 = new TileLayer({
  title: 'Máscara 20150730',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150730l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0096.setVisible(false);
  
const layer0095 = new TileLayer({
  title: 'Máscara 20150823',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20150823l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0095.setVisible(false);

export const grupoCapa01_7 = new LayerGroup({
  title: 'Ciclo Hidrológico 2014-2015',
  fold: 'close',
  layers: [layer0095, layer0096, layer0097, layer0098, layer0099, layer00100, layer00101, layer00102, layer00103, layer00104, layer00105, layer00106, layer00107, layer00108, layer00109, layer00110, layer00111, layer00112, layer00113, layer00114, layer00115, layer00116, layer00117, layer00118, layer00119]
});